// The rollback switch for PWA phase 3 (F173). false = back to phases 1–2:
// the worker at /app/sw.js with scope "/app", silent updates, no version
// check, no update card or screen. The site-wide worker unregisters itself on
// the next visit. docs/storefront-updates.md#rollback.
export const PWA_PHASE3 = true;
